import { useState, type FormEvent } from "react";
import { Modal } from "../../components/Modal";
import type { AttentionItem, WorkTask } from "../../domain/operations";
import { useOperations } from "../../state/OperationsProvider";
import { DesktopToday } from "./DesktopToday";
import { MobileToday } from "./MobileToday";

export function TodayScreen() {
  const { snapshot, setTaskStatus, resolveAttention } = useOperations();
  const [blockTask, setBlockTask] = useState<WorkTask | null>(null);
  const [reviewItem, setReviewItem] = useState<AttentionItem | null>(null);

  if (!snapshot) return null;

  function submitBlocker(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!blockTask) return;
    const data = new FormData(event.currentTarget);
    setTaskStatus(blockTask.id, "blocked", String(data.get("note") || data.get("reason")));
    setBlockTask(null);
  }

  return (
    <>
      <DesktopToday snapshot={snapshot} onStatus={setTaskStatus} onReview={setReviewItem} onResolve={resolveAttention} />
      <MobileToday snapshot={snapshot} onStatus={setTaskStatus} onBlock={setBlockTask} onReview={setReviewItem} />
      <Modal open={Boolean(blockTask)} onClose={() => setBlockTask(null)} title="Report a blocker" description="Let the operations team know what is stopping this work.">
        <form className="quick-form" onSubmit={submitBlocker}>
          <label>What is blocked?<select name="reason"><option>Missing ingredient or item</option><option>Equipment issue</option><option>Waiting on another task</option><option>Need a decision</option></select></label>
          <label>Quick note<input name="note" placeholder="Add a short note (optional)" /></label>
          <button type="submit">Send to operations</button>
        </form>
      </Modal>
      <Modal open={Boolean(reviewItem)} onClose={() => setReviewItem(null)} title={reviewItem?.title ?? "Attention item"} description={reviewItem ? `${snapshot.events.find((event) => event.id === reviewItem.eventId)?.name ?? ""} · ${reviewItem.kind}` : undefined}>
        <p>{reviewItem?.detail}</p>
        <div className="quick-form"><button onClick={() => { if (reviewItem) resolveAttention(reviewItem.id); setReviewItem(null); }}>Acknowledge update</button></div>
      </Modal>
    </>
  );
}
